import React, { useState, useEffect, useRef, useCallback, useMemo, useContext } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../Actions/AllAction';
import CustomInput from '../../Utility/Components/CustomInput'
import ErrorBoundary from '../../Utility/Components/ErrorBoundary';
import AutosuggestComponent from '../../Utility/Components/AutosuggestComponent';
import { withNamespaces } from 'react-i18next';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
import RoleTemplates from './RoleTemplates';

function CustomToggle({ children, eventKey }) {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey, () => { }
    );
    const isCurrentEventKey = activeEventKey === eventKey;
    return (
        <button type="button" className='toggle-arrow-icon' onClick={decoratedOnClick}>
            <i className={isCurrentEventKey ? "fa fa-angle-up" : "fa fa-angle-down"} aria-hidden="true"></i>
        </button>
    );
}

const formatLabel = (input) => {
    switch (input) {
        /*case 'dashboard':
            return 'Dashboard';
        case 'user':
            return 'User Profile';
        case 'personal':
            return 'Personal';
        case 'professional':
            return 'Professional';
        case 'branch':
            return 'Branches';
        case 'room_type':
            return 'Room Types';
        case 'room_price_override':
            return 'Room Price Override';
        case 'block_room':
            return 'Block Rooms';
        case 'booking_room':
            return 'Bookings';
        case 'room_facility':
            return 'Room Facilities';
        case 'amenities':
            return 'Hotel Amenities';
        case 'booking_rules':
            return 'Booking Rules';
        case 'cancellation_rules':
            return 'Cancellation Rules';
        case 'tax':
            return 'Tax Rules';
        case 'role':
            return 'Roles';
        case 'quotation':
            return 'Quotations';
        case 'credit_note':
            return 'Credit Notes';
        case 'admin_staff':
            return 'Staffs';
        case 'report':
            return 'Report';
        case 'account_payment':
            return 'Account & Payments';
        case 'beneficiaries':
            return 'Beneficiaries';
        case 'transactions':
            return 'Transactions';
        case 'pending_settlements':
            return 'Pending Settlements';
        case 'vendor_report':
            return 'Report';
        case 'demo_page':
            return 'Role Test';*/
        case 'dashboard':
            return 'Dashboard';
        case 'master_dashboard':
            return 'Master Dashboard Legacy';
        case 'master_dashboard_v2':
            return 'Master Dashboard V2';
        case 'billing_counter_dashboard':
            return 'Billing Counter Dashboard';
        case 'sales_and_orders':
            return 'Sales & Orders';
        case 'purchase_orders':
            return 'Purchase Orders';
        case 'invoices':
            return 'Invoices';
        case 'orders':
            return 'Orders';
        case 'digital_menu_orders':
            return 'Digital Menu Orders';
        case 'quotations':
            return 'Quotations';
        case 'transactions':
            return 'Transactions';
        case 'business_account':
            return 'Business Account';
        case 'accounts':
            return 'Accounts';
        case 'monthly_targets':
            return 'Monthly Targets';
        case 'business_registers':
            return 'Business Registers';
        case 'user_and_customer':
            return 'User & Customer';
        case 'users':
            return 'Users';
        case 'customers':
            return 'Customers';
        case 'roles':
            return 'Roles';
        case 'user_profile':
            return 'User Profile';
        case 'personal':
            return 'Personal';
        case 'professional':
            return 'Professional';
        case 'supplier':
            return 'Supplier';
        case 'suppliers':
            return 'Suppliers';
        case 'tax_and_discount_codes':
            return 'Tax & Discount Codes';
        case 'tax_codes':
            return 'Tax Codes';
        case 'discount_codes':
            return 'Discount Codes';
        case 'stock':
            return 'Stock';
        case 'products':
            return 'Products';
        case 'categories':
            return 'Categories';
        case 'product_label':
            return 'Product Label';
        case 'stock_transfer':
            return 'Stock Transfer';
        case 'stock_return':
            return 'Stock Return';
        case 'add_on_groups':
            return 'Add-on Groups';
        case 'bookings_and_calendar':
            return 'Bookings & Calendar';
        case 'bookings_and_events':
            return 'Bookings & Events';
        case 'calendar':
            return 'Calendar';
        case 'reports':
            return 'Reports';
        case 'download_reports':
            return 'Download Reports';
        case 'best_seller_report':
            return 'Best Seller Report';
        case 'day_wise_sale_report':
            return 'Day Wise Sale Report';
        case 'category_report':
            return 'Category Report';
        case 'stock_quantity_alert':
            return 'Stock Quantity Alert';
        case 'store_stock_chart':
            return 'Store Stock Chart';
        case 'restaurant':
            return 'Restaurant';
        case 'kitchen_display':
            return 'Kitchen Display';
        case 'tables':
            return 'Tables';
        case 'waiter_display':
            return 'Waiter Display';
        case 'restaurant_menu':
            return 'Restaurant Menu';
        case 'notification':
            return 'Notification';
        case 'notifications':
            return 'Notifications';
        case 'import_data':
            return 'Import Data';
        case 'import_data':
            return 'Import Data';
        case 'upload_users':
            return 'Upload Users';
        case 'upload_store':
            return 'Upload Store';
        case 'upload_supplier':
            return 'Upload Supplier';
        case 'upload_category':
            return 'Upload Category';
        case 'upload_product':
            return 'Upload Product';
        case 'upload_ingredient':
            return 'Upload Ingredient';
        case 'upload_add_on_product':
            return 'Upload Add-on Product';
        case 'settings':
            return 'Settings';
        case 'stores':
            return 'Stores';
        case 'payment_methods':
            return 'Payment Methods';
        case 'billing_counters':
            return 'Billing Counters';
        case 'email_settings':
            return 'Email Settings';
        case 'sms_settings':
            return 'SMS Settings';
        case 'sms_templates':
            return 'SMS Templates';
        case 'measurement_units':
            return 'Measurement Units';
        case 'variant_options':
            return 'Variant Options';
        case 'printers':
            return 'Printers';
        case 'kitchen_displays':
            return 'Kitchen Displays';
        case 'app_settings':
            return 'App Settings';
        case 'bill_posting_settings':
            return 'Bill Posting Settings';
        case 'product_audit_history':
            return 'Product Audit History';
        case 'change_in_transaction':
            return 'Transaction Audit History';
        case 'night_audit_report':
            return 'Night Audit Report';
        case 'bookings_events':
            return 'Bookings & Events';
        case 'operating_hours':
            return 'Operating Hours';
        case 'open_business_day':
            return 'Open Business Day';
        // case 'business_modal':
        //     return 'Business Day Modal';
        case 'user_profile_image':
            return 'Profile Image';
        case 'requisitions':
            return 'Requisitions';
        case 'grn':
            return 'GRN';
        default:
            return '';
    }
}

function RoleAddEditModalContent(props) {

    const rolesUi = () => {
        let uiArry = [];
        if (props.roleRawData.length > 0) {
            props.roleRawData.map((value, idx) => {
                uiArry.push(
                    <Accordion defaultActiveKey={0}>
                        <Accordion.Item eventKey={idx}>
                            <div className='accordion-header-customize'>
                                <label className='header-title'>{formatLabel(value.eventKey)}</label>
                                <div className='accorPermission'>
                                    <ul>
                                        <li>
                                            <label className="checkbox_customize">R & W
                                                <input type="checkbox"
                                                    onChange={(e) => props.menuSelected(e, value, "C")}
                                                    checked={value.crud}
                                                />
                                                <span className="checkmarktick"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label className="checkbox_customize">Read
                                                <input type="checkbox"
                                                    onChange={(e) => props.menuSelected(e, value, "R")}
                                                    checked={value.read}
                                                />
                                                <span className="checkmarktick"></span>
                                            </label>
                                        </li>
                                        <li>
                                            <label className="checkbox_customize">Write
                                                <input type="checkbox"
                                                    onChange={(e) => props.menuSelected(e, value, "W")}
                                                    checked={value.write}
                                                />
                                                <span className="checkmarktick"></span>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                                {value?.subeventKey && value.subeventKey.length > 0 && <CustomToggle eventKey={idx}></CustomToggle>}
                            </div>
                            {value?.subeventKey && value.subeventKey.length > 0 ? <Accordion.Body>
                                {submenuRole(value.subeventKey)}
                            </Accordion.Body>
                                :
                                null}
                        </Accordion.Item>
                    </Accordion>
                )
            })
        }

        return uiArry;

    }

    const submenuRole = (subRole) => {
        let uiArry = [];
        subRole.map((value, idx) => {
            uiArry.push(
                <div key={idx} className='accorSubbox'>
                    <div className='accorSubHeading'>
                        <label>{formatLabel(value.eventKey)}</label>
                    </div>
                    <ul>
                        <li>
                            <label className="checkbox_customize">R & W
                                <input type="checkbox"
                                    onChange={(e) => props.submenuSelected(e, value, "C")}
                                    checked={value.crud}
                                />
                                <span className="checkmarktick"></span>
                            </label>
                        </li>
                        <li>
                            <label className="checkbox_customize">Read
                                <input type="checkbox"
                                    onChange={(e) => props.submenuSelected(e, value, "R")}
                                    checked={value.read}
                                />
                                <span className="checkmarktick"></span>
                            </label>
                        </li>
                        <li>
                            <label className="checkbox_customize">Write
                                <input type="checkbox"
                                    onChange={(e) => props.submenuSelected(e, value, "W")}
                                    checked={value.write}
                                />
                                <span className="checkmarktick"></span>
                            </label>
                        </li>
                    </ul>
                    {value.actions && (
                        <div className='actions-section'>
                            <div className='accorSubHeading'>
                                <label>Actions</label>
                            </div>
                            <ul className='actions-list'>
                                {value.actions.hasOwnProperty('view') && (
                                    <li>
                                        <label className="checkbox_customize">View
                                            <input type="checkbox"
                                                onChange={(e) => props.actionSelected(e, value, "view")}
                                                checked={value.actions.view}
                                            />
                                            <span className="checkmarktick"></span>
                                        </label>
                                    </li>
                                )}
                                {value.actions.hasOwnProperty('create') && (
                                    <li>
                                        <label className="checkbox_customize">Create
                                            <input type="checkbox"
                                                onChange={(e) => props.actionSelected(e, value, "create")}
                                                checked={value.actions.create}
                                            />
                                            <span className="checkmarktick"></span>
                                        </label>
                                    </li>
                                )}
                                {value.actions.hasOwnProperty('export') && (
                                    <li>
                                        <label className="checkbox_customize">Export
                                            <input type="checkbox"
                                                onChange={(e) => props.actionSelected(e, value, "export")}
                                                checked={value.actions.export}
                                            />
                                            <span className="checkmarktick"></span>
                                        </label>
                                    </li>
                                )}
                                {/* Render other actions that are not view/create/export */}
                                {Object.keys(value.actions).filter(actionKey =>
                                    !['view', 'create', 'export'].includes(actionKey) &&
                                    typeof value.actions[actionKey] === 'boolean'
                                ).map(actionKey => (
                                    <li key={actionKey}>
                                        <label className="checkbox_customize">{actionKey.charAt(0).toUpperCase() + actionKey.slice(1).replace(/_/g, ' ')}
                                            <input type="checkbox"
                                                onChange={(e) => props.actionSelected(e, value, actionKey)}
                                                checked={value.actions[actionKey]}
                                            />
                                            <span className="checkmarktick"></span>
                                        </label>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )
        })
        return uiArry;
    }

    return (
        <div className="modalinnerbody">
            <div className="innerbodydimension">
                <div className="col-md-12">
                    <div className='row'>
                        <div className="col-md-6">
                            <ErrorBoundary title="RoleTemplates Error">
                                <RoleTemplates
                                    onRoleDataChange={props.onRoleDataChange}
                                    roleRawData={props.roleRawData}
                                    onRoleNameChange={(name) => {
                                        const event = { target: { value: name } };
                                        props.handelChange(event, 'role_name');
                                    }}
                                    currentStore={props.currentStore}
                                />
                            </ErrorBoundary>
                        </div>
                        <div className="col-md-6">
                            <div className="col-md-12">
                                <ErrorBoundary title="CustomInput Error">
                                    <CustomInput
                                        parentClassName="input_field_inner"
                                        labelName="Role Name"
                                        errorLabel={props.roleNameError}
                                        name="role_name"
                                        type="text"
                                        value={props.roleName}
                                        onChange={(e) => props.handelChange(e, 'role_name')}
                                        labelPresent={true}
                                    />
                                </ErrorBoundary>
                            </div>
                            <div className="col-md-12">
                                <ErrorBoundary title="CustomInput Error">
                                    <div className="dropdowninnerboxContainer">
                                        <label>Branch Name <span>*</span></label>
                                        <AutosuggestComponent
                                            handleOnChange={(e) => props.handelChange(e, "branch_name")}
                                            options={props.branchList}
                                            selectedValue={props.selectedBranch}
                                            name=''
                                            isMulti={false}
                                            placeholder=""
                                            isDisabled={false}
                                            isSearchable={true}
                                            classNamePrefix="dropdown-default"
                                        />
                                        <div className="col-md-12 errorClass error_div">{props.branchNameError}</div>
                                    </div>
                                </ErrorBoundary>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className='accorPanelSec'>
                        {rolesUi()}
                    </div>

                </div>
            </div>
            <div className="col-md-12 text-center topspace">
                <button type="button" className="modBtnSave" onClick={(e) => props.roleDataSave()}>{props.editedFlag ? 'Update' : props.t('save')}</button>
                <button type="button" className="modBtnSave cancelbtn" onClick={(e) => props.closeRoleModal()}>Cancel</button>
            </div>
        </div>
    );
};

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        currentStore: globalState.StoreReducer.currentStore
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse })(withNamespaces()(RoleAddEditModalContent));
